import * as models from 'smg/customer-api/models';
import * as template from 'smg/template';

import { State } from '../../state';

import { BindBackLink, PromoteFormBodyIDs, SetupBillingAddressWithToggle } from './shared';

// RenderSimpleForm handles payment methods that have no type-specific
// inputs beyond a billing address — check and wire transfer. The caller
// passes the template ID so this renderer stays content-agnostic.
export function RenderSimpleForm(state: State, $el: HTMLElement, back: () => void, templateID: string): void {
    $el.replaceChildren(template.Clone(templateID));
    PromoteFormBodyIDs($el);
    SetupBillingAddressWithToggle(state, $el);
    const typeID = state.payment.paymentOptionTypeID ?? models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CHECK;
    state.initPaymentTypeSelect(typeID, $el);
    BindBackLink($el, back);
}
